<mat-form-field [appearance]="appearance">
    @if (label) {
        <mat-label>{{ label }}</mat-label>
    }

    <mat-select [formControl]="selectControl" [multiple]="multiple" [placeholder]="placeholder">
        @for (option of options; track option.id) {
            @if (translateOptions) {
                <mat-option [value]="option.id">
                    {{ option.name | translate }}
                </mat-option>
            } @else {
                <mat-option [value]="option.id">
                    {{ option.name }}
                </mat-option>
            }
        }
    </mat-select>

    <mat-error>{{ selectControl?.errors | validationMessage }}</mat-error>
</mat-form-field>
